<template>
	<div class="nosotros">
		<v-container  
				class="overflow-y-auto"
		>
			<v-layout row >
				<v-flex md9 xs12 class="pt-5 pa-4">
					<h1>Nosotros</h1>

					<h2>Historia</h2>  

					<span>

					Ley de Creación: Ley N°138
					Fecha de Creación   : 21 de diciembre de 1832

					Fecha de Instalación: 28 de Julio de 1850

					Bajo la Presidencia de: Mrcal. Agustín Gamarra
					Primer Presidente: Dr. Juan Cazorla
					Juramento Ante: Prefecto Alejandro Deústua
					Primeros Vocales: Dr. Juan Antonio Macedo, Dr. Mariano Paredes
					Primera Sala: Tribunal Superior de Justicia de Puno.

					</span>
				</v-flex>
				<v-flex md3 xs12>
					<Servicios />
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>
<script>
const Servicios = () => import('@/components/Servicios.vue')

export default {
	components: {
        Servicios
    },
}
</script>
